export const API_URL = "https://staging.api.topcoinuk.com"; 